
const initial_data = {
      "id": "",
      "mfl_code": null,
      "name": "",
      "county": "",
      "sub_county": "",
      "owner": "",
      "lat": null,
      "lon": null,
      "partner": "",
      "agency": "",
      "emr_site": false,
      "non_emr_site": false,
      "asal": false,
      "pepfar": false,
      "infrastructure_type": "",
      "KEPH_Level": "",
      "KMPDC_reg_no":"",
      "ward":"",
      "CT": false,
      "HTS": false,
      "IL": false,
      "mHealth": false,
      "KP":false,
      "ovc_offered": null,
      "otz_offered": null,
      "tb_offered": null,
      "prep_offered": null,
      "mnch_offered": null,
      "kp_offered": null,
      "lab_man_offered": null,
      "hiv_offered": null, 
      "tpt_offered": null, 
      "covid_19_offered": null, 
      "evmmc_offered": null,
      "mhealth_ushauri": null,
      "mhealth_nishauri": null,
      "mhealth_c4c": null,
      "mhealth_mlab": null,
      "mhealth_psurvey": null,
      "mhealth_art": null,
      "il_status": null,
      "webADT_registration": null,
      "webADT_pharmacy": null,
      "il_three_PM": null,
      "il_air": null,
      "il_ushauri": null,
      "il_mlab": null,
      "il_lab_manifest": null, 
      "il_nimeconfirm": null,
      "emr_type": null,
      "emr_status": null,
      "mode_of_use":null,
      "date_of_emr_impl":null,
      "hts_use": null,
      "hts_deployment": null,
      "hts_status": null,
      "confidential": null,
      "facility_wide_site": false,
      "hiv_clinic_site": false,
      "date_of_init": null,
      "ownership_category": null,
      "len_prep": false,

      "registration": false, "triage": false,"consultation": false,
      "mch": false, "admissions": false, "procedures": false, "radiology_imaging": false,
"laboratory": false, "pharmacy": false, "mortuary": false, "stock_management": false,
"medical_supplies": false, "accounting": false, "dashboards": false, "reports": false,
"nda_signed":false, "hie_activated":false, "modules_status":null, "facility_wide_status":null,
      "FID_code":""

}

    export default initial_data
